import { Erc20AirdropCSV } from './actions/Erc20Airdrop';
import { Erc20ApprovalsCSV } from './actions/Erc20Approvals';
import { Erc20MonoTransfersCSV } from './actions/Erc20MonoTransfers';
import { Erc20TransfersCSV } from './actions/Erc20Transfers';
import { TrasnfersCSV } from './actions/Trasnfers';
import { MultiAllowanceCSV } from './getters/MultiAllowance';
import { MultiBalanceCSV } from './getters/MultiBalance';
var actions = {
    Erc20AirdropCSV: Erc20AirdropCSV,
    Erc20ApprovalsCSV: Erc20ApprovalsCSV,
    Erc20MonoTransfersCSV: Erc20MonoTransfersCSV,
    Erc20TransfersCSV: Erc20TransfersCSV,
    TrasnfersCSV: TrasnfersCSV,
};
var getters = {
    MultiAllowanceCSV: MultiAllowanceCSV,
    MultiBalanceCSV: MultiBalanceCSV,
};
var KIROBO_MULTICALL_CSV = {
    actions: actions,
    getters: getters,
};
export { KIROBO_MULTICALL_CSV };
